import { productCarouselStyles as styles } from "@insite/content-library/Widgets/Common/ProductCarousel";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { buttonIconOnlyCommonStyles } from "@solveindustrial/Utilities/styleguide";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.titleText = {
    ...styles.titleText,
    css: css`
        ${styles.titleText?.css}
        text-align: left;
        margin-bottom: 40px;
    `,
};

styles.mainContainer = {
    ...styles.mainContainer,
    offsetCss: css`
        ${styles.mainContainer?.offsetCss}

        &&& {
            justify-content: center;
        }
    `,
};

styles.carouselGridItem = {
    ...styles.carouselGridItem,
    css: css`
        ${styles.carouselGridItem?.css}

        &&& {
            order: 0;
            flex-basis: 100%;
            margin: 10px -10px 16px;
            max-width: 100%;
            width: 100%;
        }
    `,
};

styles.prevArrowGridItem = {
    ...styles.prevArrowGridItem,
    css: css`
        ${styles.prevArrowGridItem?.css}

        &&& {
            order: 1;
            margin-right: 4px;
            flex-basis: 24px;
            max-width: 24px;
            width: 24px;
            margin-inline-start: auto;
        }
    `,
};

styles.prevArrowButton = {
    ...styles.prevArrowButton,
    ...buttonIconOnlyCommonStyles,
};

styles.nextArrowGridItem = {
    ...styles.nextArrowGridItem,
    css: css`
        ${styles.nextArrowGridItem?.css}

        &&& {
            order: 2;
            margin-left: 4px;
            flex-basis: 24px;
            max-width: 24px;
            width: 24px;
        }
    `,
};

styles.nextArrowButton = {
    ...styles.nextArrowButton,
    ...buttonIconOnlyCommonStyles,
};

styles.carouselSlide = {
    ...styles.carouselSlide,
    css: css`
        ${styles.carouselSlide?.css}
        padding: 0 8px;
    `,
};

styles.carouselSlideInner = {
    ...styles.carouselSlideInner,
    css: css`
        ${styles.carouselSlideInner?.css};
        border: 1px solid ${getColor(colorStrings.commonBorder)};
        padding: 16px;
        border-radius: 4px;
        gap: 10px;
    `,
};
